import React from 'react'
import BaseComponent from './BaseComponent'
import _ from 'lodash'
import { NavLink } from 'react-router-dom'
import Footer from './Footer'
import SideNav from './SideNav'
import Modal from './Modal'
import $ from 'jquery'
import Parsley from 'parsleyjs'

Math.decimal = function(n, k) 
{
    var factor = Math.pow(10, k+1);
    n = Math.round(Math.round(n*factor)/10);
    return n/(factor/10);
}

export default class ProductPage extends BaseComponent {

  constructor(props) {
  	super(props)
    this.state = { activeColor: 0, activeImage: 0, info: 0, popup: false, popupType: "", message: "", name: "", phone: "", email: "", quantity: 0, quantitymb: 0, priceGross: 0, priceNet: 0, area: 0, length: 0 }
    this._bind('setColor', 'setImage', 'setInfo', 'openPopup', 'hidePopup', 'handleInputChange', 'showImage', 'sendForm', 'submitForm')
    this.product = _.filter(this.props.data.products, {slug: this.props.match.params.name })[0]
  }

  setColor(id) {
    this.setState({ activeColor: id })
  }

  setImage(id) {

    if (id >= 0 && id < this.product.gallery.length) {
      this.setState({ activeImage: id })
    }
  }

  showImage(i) {
    this.setState({ image: i, popup: true, popupType: "image" })
  }

  setInfo(name) {
    this.setState({ info: name })
  }

  openPopup(name) {
      this.setState({ popup: true, popupType: name })
  }

  hidePopup() {
      this.setState({ popup: false })
  }

  sendForm(e) {
    e.preventDefault()

    if($('.form').parsley().validate()) {
      this.submitForm()
    }
  }

  submitForm() {

    let title = ""
    if (this.state.popupType === "contact") {
      title = "Formularz WWW - Prośba o kontakt"
    } else if (this.state.popupType === "question") {
      title = "Formularz WWW - Zapytanie o produkt"
    } else if (this.state.popupType === "order") {
      title = "Formularz WWW - Zamówienie"
    }

    let data = {
      title: title,
      name: this.state.name,
      phone: this.state.phone,
      email: this.state.email,
      message: this.state.message,
      quantity: this.state.quantitymb ? this.state.quantitymb : this.state.quantity,
      product: this.product.title,
      price: this.state.priceGross,
      color: this.product.colors[this.state.activeColor].name
    }

    fetch('/mailer/index.php', {
        method: "POST", 
        headers: {
            "Content-Type": "application/json; charset=utf-8"
        },
        body: JSON.stringify(data),
    })
    .then((response, status) => {
      return response.json()
    })
    .then((result) => {
      if (result.result === 0) {
        this.openPopup("error")
      } else {
        this.openPopup("success")
      }
    },(error) => {
      this.openPopup("error")
      console.log(error)
    })
  }

  handleInputChange(event) {
    const target = event.target
    let value = target.type === 'checkbox' ? target.checked : target.value
    let name = target.name

    switch(name){
        case 'quantity':
            this.setState({
              quantity: value,
              priceGross: Math.decimal(value*this.product.net_price*1.23, 2),
              priceNet: Math.decimal(value*this.product.net_price, 2),
              area: Math.decimal(value*this.product.area, 2)
            })
        break
        case 'quantitymb':
            this.setState({
              quantitymb: value,
              priceGross: Math.decimal(value*this.product.net_price*1.23, 2),
              priceNet: Math.decimal(value*this.product.net_price, 2),
              length: Math.decimal(value*this.product.area, 2)
            })
        break
        case 'priceNet':
            // this.setState({
            //   priceGross: Math.decimal(value*1.23,2),
            //   priceNet: value,
            //   area: Math.decimal(value*this.product.area,2),
            //   quantity: Math.round(Math.decimal(value*this.product.net_price*1.23/this.product.net_price*1.23,2) + 0.49)
            // })
        break
        case 'priceGross':
            // this.setState({
            //   priceGross: value,
            //   priceNet: Math.decimal(value/1.23, 2),
            //   area: Math.decimal(value/1.23*this.product.area,2),
            //   quantity: Math.round(Math.decimal(value/1.23*this.product.net_price*1.23/this.product.net_price*1.23,2) + 0.49)
            // })
        break
        case 'area':
            this.setState({
              priceGross: Math.decimal(Math.round(Math.decimal(value/this.product.area,2) + 0.49)*this.product.net_price*1.23,2),
              priceNet: Math.decimal(Math.round(Math.decimal(value/this.product.area,2) + 0.49)*this.product.net_price,2),
              area: value,
              quantity: Math.round(Math.decimal(value/this.product.area,2) + 0.49)
            })
        break
        case 'length':
            this.setState({
              priceGross: Math.decimal(Math.round(Math.decimal(value/this.product.area,2))*this.product.net_price*1.23,2),
              priceNet: Math.decimal(Math.round(Math.decimal(value/this.product.area,2))*this.product.net_price,2),
              length: value,
              quantitymb: Math.round(Math.decimal(value/this.product.area,2) + 0.49)
            })
        break
        default:
          this.setState({
            [name]: value
          })
        break
    }
  }

  render() {
    let popupInner
    switch(this.state.popupType) {
      case 'calc':
        popupInner = (
          <div></div>
        )
      break
      case 'order':
        if ((this.state.quantity === 0 && this.state.quantitymb === 0 )) {
          popupInner = (
            <div className="order-popup popup-inner">
              <img className="icon" src="/assets/img/calc-icon-big.png" alt="icon"/>
              { this.product.calc === "1" ? <h3>Wypełnij kalkulator zamówienia</h3> : <h3>Wybierz ilość</h3> }
              <img className="calc-screen" src="/assets/img/calc-screen.png" alt="calc screen"/>
            </div>
          )
        } else {
          popupInner = (
            <div className="order-popup popup-inner">
              <h3 className="popup-title"><img className="icon" src="/assets/img/order-icon-big.png" alt="icon"/><span>Złóż zamówienie</span></h3>
              <div className="prod">
                <div className="img"><img src={ this.product.image } alt={ this.product.title }/></div>
                <div className="text">
                  <h4>{ _.filter(this.props.data.categories, { id: this.product.category })[0].title }</h4>
                  <p>{ this.product.title }</p>
                  { this.product.colors.length > 0 ? <div className="color" style={{ backgroundColor: this.product.colors[this.state.activeColor].color }}></div> : null }
                  <p className="quantity">{ this.product.unit === "m2" ? this.state.quantity : this.state.quantitymb } szt.</p>
                  <p className="price">{ this.product.offer ? Math.decimal(this.state.priceGross - this.state.priceGross*(this.product.offer_percentage/100),2).toFixed(2) : this.state.priceGross.toFixed(2) } zł brutto</p>
                </div>
              </div>
              <form className="form">
                <input placeholder="Imię i nazwisko" type="text" name="name" onChange={ this.handleInputChange } value={ this.state.name } required/>
                <input className="email" placeholder="Email" type="email" name="email" onChange={ this.handleInputChange } value={ this.state.email } required/>
                <input className="phone" placeholder="Telefon" type="text" name="phone" onChange={ this.handleInputChange } value={ this.state.phone } required/>
                <textarea placeholder="Wiadomość" name="message" onChange={ this.handleInputChange } value={ this.state.message }></textarea>
              </form>
              <a className="btn" onClick={ this.sendForm }>Składam zamówienie</a>
            </div>
          )
        }
      break
      case 'contact':
        popupInner = (
            <div className="order-popup popup-inner">
              <img className="icon" src="/assets/img/contact-icon-big.png" alt="icon"/>
              <h3 className="popup-title">Zostaw dane<br/>skontaktujemy się z Tobą</h3>
              <p>Skontaktujemy się z Tobą w ciągu 24h</p>
              <form className="form">
                <input placeholder="Imię i nazwisko" type="text" name="name" onChange={ this.handleInputChange } value={ this.state.name } required/>
                <input className="email" placeholder="Email" type="email" name="email" onChange={ this.handleInputChange } value={ this.state.email } required/>
                <input className="phone" placeholder="Telefon" type="text" name="phone" onChange={ this.handleInputChange } value={ this.state.phone } required/>
              </form>
              <a className="btn" onClick={ this.sendForm }>Wyślij dane</a>
            </div>
          )
      break
      case 'success':
        popupInner = (
            <div className="popup-inner">
              <h1>Dziękujemy</h1>
              <h4>Za zainteresowanie naszą ofertą</h4>
              <p>Skontaktujemy się z Państwem najszybciej jak to możliwe.</p>
              <button className="btn" onClick={ this.hidePopup }><span>Zamknij</span><div className="close-modal"></div></button>
            </div>
          )
      break
      case 'error':
        popupInner = (
            <div className="popup-inner">
              <h1>Wystąpił błąd!</h1>
              <p>Prosimy spróbować ponownie.</p>
              <button className="btn" onClick={ this.hidePopup }><span>Zamknij</span><div className="close-modal"></div></button>
            </div>
          )
      break
      case 'question':
        popupInner = (
            <div className="order-popup popup-inner">
              <img className="icon" src="/assets/img/question-icon-big.png" alt="icon"/>
              <h3 className="popup-title">Zadaj pytanie<br/>o ten produkt</h3>
              <p>Odpowiemy na Twoje pytanie jak najszybciej</p>
              <form className="form">
                <input placeholder="Imię i nazwisko" type="text" name="name" onChange={ this.handleInputChange } value={ this.state.name } required/>
                <input className="email" placeholder="Email" type="email" name="email" onChange={ this.handleInputChange } value={ this.state.email } required/>
                <input className="phone" placeholder="Telefon" type="text" name="phone" onChange={ this.handleInputChange } value={ this.state.phone } required/>
                <textarea placeholder="Wiadomość" name="message" onChange={ this.handleInputChange } value={ this.state.message }></textarea>
              </form>
              <a className="btn" onClick={ this.sendForm }>Wyślij wiadomość</a>
            </div>
          )
      break
      default:
        popupInner = (
          <div className="image product">
            { this.state.activeImage > 0 ? <div className="prev" onClick={ this.setImage.bind(null, this.state.activeImage-1) }></div> : null }
            <div className="close" onClick={ this.hidePopup }></div>
            { this.product.gallery.length > 0 ? <img src={ this.product.gallery[this.state.activeImage] } alt=""/> : null }
            { this.state.activeImage < this.product.gallery.length-1 ? <div className="next" onClick={ this.setImage.bind(null, this.state.activeImage+1) }></div> : null }
          </div>
        )
      break
    }

    let Popup = (
      <div className="thank-you">
        <div className="close" onClick={ this.hidePopup }></div>
        { popupInner }
      </div>
    )

    let gal = []

    if (this.product && this.product.gallery !== "") {
      gal = this.product.gallery
    }

    let thumbnails = gal.map((item, i) => {
      return (
        <li key={ i } onClick={ this.setImage.bind(null, i) } className={ this.state.activeImage === i ? "active" : "" }>
          <img src={ item } alt=""/>
        </li>
      )
    })

    let relatedProducts = []

    if (this.product.related) {
      for (var i = 0; i < this.product.related.length; i++) {
        let temp = _.filter(this.props.data.products, { id: this.product.related[i].id })[0]
        if (temp) {
          relatedProducts.push(temp)
        }
      }
    }

    let related = relatedProducts.map((item, i) => {
      return (
        <li key={ i } className="product-item">
          <div className="image">
            <img src={ item.image } alt="prod logo"/>
          </div>
          <h4>{ item.title }</h4>
          <p>{ item.head }</p>
          <NavLink to={ "/produkt/" + item.slug } className="btn">Sprawdź</NavLink>
        </li>
      )
    })

    let colors = this.product.colors.map((item, i) => {
      return (
        <li key={ i } style={{ backgroundColor: item.color }} className={ this.state.activeColor === i ? "active" : "" } onClick={ this.setColor.bind(null, i) }></li>
      )
    })

    let listWrap = this.product.list || []

    let list = listWrap.map((item, i) => {
      return (
        <li key={ i } onClick={ this.setInfo.bind(null, i) } className={ this.state.info === i ? "active" : "" }><a>{ item.title }</a></li>
      )
    })

    return (
      <section className="product">
        <ul className="breadcrumbs">
          <div className="container-big">
            <li><NavLink to="/">Strona główna</NavLink></li>
            <li><NavLink to="/oferta">Oferta</NavLink></li>
            <li><NavLink to={ "/produkt/" + this.product.slug }>{ this.product.title }</NavLink></li>
          </div>
          <div className="bottom"></div>
        </ul>
        <div className="outer-container">
          <SideNav data={ this.props.data }/>
        	<div className="container">
            <div className="top">
              <div className="first">
                <div className="name">
                  <h1>{ _.filter(this.props.data.categories, { id: this.product.category })[0].title }</h1>
                  <p>{ this.product.title }</p>
                  <img className="icon" src={ this.product.icon } alt="icon"/>
                </div>
                <div className="price">
                  { parseInt(this.product.offer_percentage, 10) > 0 ? <p className="old-price">cena przed promocją: <span>{ (this.product.net_price*1.23).toFixed(2) } pln/szt.</span></p> : null }
                  <div className="actual-price">
                    <h4>Cena<br/>brutto:</h4>
                    <p><span>{ parseInt(this.product.offer_percentage, 10) > 0 ? Math.decimal(this.product.net_price*1.23 - this.product.net_price*1.23*(this.product.offer_percentage/100), 2).toFixed(2) : (this.product.net_price*1.23).toFixed(2) }</span>pln/szt.</p>
                  </div>
                </div>
                <div className="additional-desc" dangerouslySetInnerHTML={{ __html: this.product.short }}></div>
                { this.product.calc === "1" ? <div className="calc">
                  <h3>Kalkulator zamówienia</h3>
                  <div className="inputs">
                    <div className="input first-input">
                      { this.product.unit === "m2" ? <label htmlFor="input1">m<sup>2</sup> powierzchni:</label> : <label htmlFor="input1">ilość mb:</label> }
                      { this.product.unit === "m2" ? <input min="0" type="number" name="area" onChange={ this.handleInputChange } value={ this.state.area } id="input1"/> : <input min="0" type="number" name="length" onChange={ this.handleInputChange } value={ this.state.length } id="input1"/> }
                    </div>
                    <div className="input">
                      <label htmlFor="input2">Wartość netto:</label>
                      <input disabled type="number" name="priceNet" value={ parseInt(this.product.offer_percentage, 10) > 0 ? Math.decimal(this.state.priceNet - this.state.priceNet*(this.product.offer_percentage/100), 2).toFixed(2) : Math.decimal(this.state.priceNet, 2).toFixed(2) } id="input2"/>
                    </div>
                    <div className="input">
                      <label htmlFor="input3">Wartość brutto:</label>
                      <input disabled type="number" name="priceGross" value={ parseInt(this.product.offer_percentage, 10) > 0 ? Math.decimal(this.state.priceGross - this.state.priceGross*(this.product.offer_percentage/100), 2).toFixed(2) : Math.decimal(this.state.priceGross, 2).toFixed(2) } id="input3"/>
                    </div>
                    <div className="input last">
                      <label htmlFor="input4">Zamawiana ilość produktów:</label>
                      { this.product.unit === "m2" ? <input min="0" type="number" name="quantity" onChange={ this.handleInputChange } value={ this.state.quantity } id="input4"/> : <input min="0" type="number" name="quantitymb" onChange={ this.handleInputChange } value={ this.state.quantitymb } id="input4"/> }
                    </div>
                  </div>
                </div> : <div className="input last">
                  <label htmlFor="input4">Zamawiana ilość produktów:</label>
                  { this.product.unit === "m2" ? <input min="0" type="number" name="quantity" onChange={ this.handleInputChange } value={ this.state.quantity } id="input4"/> : <input min="0" type="number" name="quantitymb" onChange={ this.handleInputChange } value={ this.state.quantitymb } id="input4"/> }
                </div> }
                <div className="color">
                  <p>Wybierz kolor: </p>
                  <ul className="colors-list">
                    { colors }
                  </ul>
                </div>
                <div className="order">
                  <a className="order-btn" onClick={ this.openPopup.bind(null, 'order') }><img src="/assets/img/order-icon.png" alt=""/><span>Złóż zamówienie</span></a>
                  <a className="order-btn full" onClick={ this.openPopup.bind(null, 'contact') }><img src="/assets/img/contact-icon.png" alt=""/><span>Zostaw dane - skontaktujemy się z Tobą</span></a>
                  <a className="order-btn" onClick={ this.openPopup.bind(null, 'question') }><img src="/assets/img/question-icon.png" alt=""/><span>Zadaj pytanie o ten produkt</span></a>
                </div>
              </div>
              <div className="second">
                <div className="gallery">
                  <ul className="thumbnails">
                    { thumbnails }
                  </ul>
                  <div className="image">
                    <img src={ gal[this.state.activeImage] } alt="" onClick={ this.showImage.bind(null, this.state.activeImage) }/>
                    { parseInt(this.product.offer_percentage, 10) > 0 ? <div className="special-offer"><span>{ this.product.offer_percentage }%</span></div> : null }
                  </div>
                </div>
                <div className="product-info">
                  <ul className="product-info-nav">
                    { list }
                  </ul>
                  <div className="content" dangerouslySetInnerHTML={{ __html: this.product.list && this.product.list.length > 0 ? this.product.list[this.state.info].description : "" }}></div>
                </div>
              </div>
            </div>
            { this.product.related && this.product.related.length > 0 ? <div className="related">
              <h1>Produkty <span>Powiązane</span></h1>
              <ul className="related-list">
                { related }
              </ul>
            </div> : null }
          </div>
        </div>
        <Footer data={ this.props.data } settings={ this.props.data.settings }/>
        <Modal open={ this.state.popup } hidePopup={ this.hidePopup }>{ Popup }</Modal>
      </section>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/ProductPage.js